module.exports = __webpack_public_path__ + "media/prk/assets/images/icons/cloud-inactive-131727ec83e92e09a5ea44f02e690cd8.svg";